import { atom } from 'recoil'
import { keyFactory } from 'src/utils/recoil'

const key = keyFactory('main-map-tools')

export type MapTools =
  | 'pins'
  | 'pins-filter'
  | 'brands'
  | 'borders'
  | 'heatmap'
  | 'zoning'
  | 'user-lists'
  | 'draw'
  | null
export const mapPinsTools = atom<MapTools>({
  key: key('map-pins-tools'),
  default: null,
})
